export default {
  'formandbasic-form.basic.title': 'Basic form',
  'formandbasic-form.basic.description':
    'Form pages are used to collect or verify information to users, and basic forms are common in scenarios where there are fewer data items.',

  'formandbasic-form.email.required': 'Please enter your email!',
  'formandbasic-form.email.wrong-format': 'The email address is in the wrong format!',
  'formandbasic-form.userName.required': 'Please enter your userName!',
  'formandbasic-form.password.required': 'Please enter your password!',
  'formandbasic-form.password.twice': 'The passwords entered twice do not match!',
  'formandbasic-form.strength.msg':
    "Please enter at least 6 characters and don't use passwords that are easy to guess.",
  'formandbasic-form.strength.strong': 'Strength: strong',
  'formandbasic-form.strength.medium': 'Strength: medium',
  'formandbasic-form.strength.short': 'Strength: too short',
  'formandbasic-form.confirm-password.required': 'Please confirm your password!',
  'formandbasic-form.phone-number.required': 'Please enter your phone number!',
  'formandbasic-form.phone-number.wrong-format': 'Malformed phone number!',
  'formandbasic-form.verification-code.required': 'Please enter the verification code!',
  'formandbasic-form.title.required': 'Please enter a title',
  'formandbasic-form.date.required': 'Please select the start and end date',
  'formandbasic-form.goal.required': 'Please enter a description of the goal',
  'formandbasic-form.standard.required': 'Please enter a metric',

  'formandbasic-form.form.get-captcha': 'Get Captcha',
  'formandbasic-form.captcha.second': 'sec',
  'formandbasic-form.form.optional': ' (optional) ',
  'formandbasic-form.form.submit': 'Submit',
  'formandbasic-form.form.save': 'Save',
  'formandbasic-form.email.placeholder': 'Email',
  'formandbasic-form.password.placeholder': 'Password',
  'formandbasic-form.confirm-password.placeholder': 'Confirm password',
  'formandbasic-form.phone-number.placeholder': 'Phone number',
  'formandbasic-form.verification-code.placeholder': 'Verification code',
  'formandbasic-form.title.label': 'Title',
  'formandbasic-form.title.placeholder': 'Give the target a name',
  'formandbasic-form.date.label': 'Start and end date',
  'formandbasic-form.placeholder.start': 'Start date',
  'formandbasic-form.placeholder.end': 'End date',
  'formandbasic-form.goal.label': 'Goal description',
  'formandbasic-form.goal.placeholder': 'Please enter your work goals',
  'formandbasic-form.standard.label': 'Metrics',
  'formandbasic-form.standard.placeholder': 'Please enter a metric',
  'formandbasic-form.client.label': 'Client',
  'formandbasic-form.label.tooltip': 'Target service object',
  'formandbasic-form.client.placeholder':
    'Please describe your customer service, internal customers directly @ Name / job number',
  'formandbasic-form.invites.label': 'Inviting critics',
  'formandbasic-form.invites.placeholder':
    'Please direct @ Name / job number, you can invite up to 5 people',
  'formandbasic-form.weight.label': 'Weight',
  'formandbasic-form.weight.placeholder': 'Please enter weight',
  'formandbasic-form.public.label': 'Target disclosure',
  'formandbasic-form.label.help': 'Customers and invitees are shared by default',
  'formandbasic-form.radio.public': 'Public',
  'formandbasic-form.radio.partially-public': 'Partially public',
  'formandbasic-form.radio.private': 'Private',
  'formandbasic-form.publicUsers.placeholder': 'Open to',
  'formandbasic-form.option.A': 'Colleague A',
  'formandbasic-form.option.B': 'Colleague B',
  'formandbasic-form.option.C': 'Colleague C',
};
